export function transformQueryToDict() {
    var params = {};
    if (location.search) {
        var parts = location.search.substring(1).split('&');
        for (var i = 0; i < parts.length; i++) {
            var query = parts[i].split('=');
            if (!query[0]) continue;
            params[query[0]] = query[1] || true;
        }
    }
    return params;
}

export function setCookie(cname, cvalue, exdays) {
    var date = new Date();
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + date.toUTCString();
    document.cookie = cname + '=' + decodeURI(cvalue) + ';' + expires + ';path=/';
}

export function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookie = decodedCookie.split(';');
    for (var i = 0; i < cookie.length; i++) {
        var char = cookie[i];
        while (char.charAt(0) == ' ') {
            char = char.substring(1);
        }
        if (char.indexOf(name) == 0) {
            return char.substring(name.length, char.length);
        }
    }
    return ''
}

export function getDateWithinLastDay(currdate, ts) {
    var oneDayInMilliseconds = 86400000;
    return currdate - ts < oneDayInMilliseconds ? true : false;
}

export function getOrSetCookie(cname, cvalue, isInLastDay) {
    if (isInLastDay == undefined) {
        isInLastDay = false;
    }
    if (!getCookie(cname)) {
        setCookie(cname, cvalue, 90);
        return true
    } else {
        var existingCookie = getCookie(cname);
        var tsCookie = cname == 'utm_ts' ? existingCookie.split(',') : getCookie('utm_ts').split(',');
        var lastTS = parseInt(tsCookie[tsCookie.length - 1]);
        var isWithinLastDay = getDateWithinLastDay(new Date().getTime(), lastTS);
        if (isInLastDay && isWithinLastDay) {
            return false;
        } else {
            var newCookie = existingCookie + ', ' + cvalue;
            setCookie(cname, newCookie, 90);
            return true;
        }
    }
}

export function isSearchEngine(referrer) {
    if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
        return 'google';
    } else if (referrer.search('https?://(.*)bing.com') === 0) {
        return 'bing';
    } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
        return 'yahoo';
    } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
        return 'duckduckgo';
    } else {
        return null;
    }
}

export function isSearchPage(path) {
    const searchPages = ['/blog', '/company', '/content', '/customers', '/events',
                        '/fleet-terms', '/guides', '/industries', '/mission',
                        '/products', '/research', '/resources', '/roi-calculator',
                        'solutions', '/videos'];

    let searchPage = false;
    searchPages.forEach(function(page) {
        if (!searchPage) {
            searchPage = path.indexOf(page) > -1;
        }
    });
    return searchPage;
}

export function determineOrigin(referrer, path) {
    var search_engine = isSearchEngine(referrer);
    var wasUpdated = false;

    if (search_engine) {
        if (isSearchPage(path)) {
            getOrSetCookie('utm_source', 'SEO', true);
            wasUpdated = getOrSetCookie('utm_campaign', path, true);
        } else if (path.split('/')[1] === '' || path.split('/')[2] === '') {
            getOrSetCookie('utm_source', 'Branded');
            wasUpdated = getOrSetCookie('utm_campaign', path, true);
        }
    } else if (!referrer) {
        getOrSetCookie('utm_source', 'Direct', true);
        wasUpdated = getOrSetCookie('utm_campaign', path, true);
    } else if (referrer && !referrer.indexOf('https://www.samsara.com') > -1) {
        getOrSetCookie('utm_source', 'Branded', true);
        wasUpdated = getOrSetCookie('utm_campaign', path, true);
    }
    if (wasUpdated) {
        getOrSetCookie('utm_ts', new Date().getTime());
    }
}

export function setUTMCookies(wasUpdated, params) {
    var list_of_utms = ['keyword', 'utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term', 'utm_ext_ad_id', 'utm_ext_adset_id', 'utm_ext_campaign_id', 'gclid', '_mkto_trk', 'msclkid'];
    for (var i = 0; i < list_of_utms.length; i++) {
        var utm = list_of_utms[i];
        if (utm in params) {
            wasUpdated = getOrSetCookie(utm, params[utm], true);
        }
    }
    return wasUpdated;
}

export function setTSCookie(wasUpdated) {
    if (wasUpdated) {
        getOrSetCookie('utm_ts', new Date().getTime(), true);
    }
}

export function setOneTimeCookie(cookie, value) {
    if (!getCookie(cookie)) {
        setCookie(cookie, value, 90);
    }
}

export function setCIDCookie(params) {
    if (!getCookie('cid') && ('cid' in params)) {
        setCookie('cid', params['cid'], 90);
    }
}
